import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TruncateStringPipe } from './truncate-string.pipe';

@NgModule({
  declarations: [TruncateStringPipe],
  exports: [TruncateStringPipe],
  imports: [CommonModule],
})
export class TruncateStringModule {}
